import { Component } from '@angular/core'

import { OAuthService } from 'angular-oauth2-oidc'
import { filter } from 'rxjs'

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  isLoggedIn = this.oAuthService.hasValidAccessToken()

  constructor(private oAuthService: OAuthService) {}

  ngOnInit(): void {
    this.oAuthService.events.pipe(filter((e) => e.type === 'token_received')).subscribe(() => {
      this.isLoggedIn = this.oAuthService.hasValidAccessToken()
    })
  }

  onLogin() {
    this.oAuthService.initLoginFlow()
  }

  onLogout() {
    this.oAuthService.logOut({ client_id: this.oAuthService.clientId, logout_uri: this.oAuthService.redirectUri })
  }
}
